/*=========================================================================================
  File Name: moduleUserManagement.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleDashboardManagementState.js'
//import mutations from './moduleUserManagementMutations.js'
import actions from './moduleDashboardManagementActions.js'
//import getters from './moduleUserManagementGetters.js'
import { getField, updateField } from 'vuex-map-fields';
export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations: {
    SET_DEPOSIT (state, deposit) {
      state.deposit = deposit;
    },
    SET_ACTIVEUSERS (state, usersactive) {
      state.usersactive = usersactive;
    },
    SET_KRUNGSRI (state, krungsri) {
      state.krungsri = krungsri;
    },
    SET_WITHDRAW (state, withdraw) {
      state.withdraw = withdraw;
    },
    SET_STATEMENT (state, statement) {
      state.statement = statement;
    },
    SET_POPUP (state, popup) {
      state.popup = popup;
    },
    SET_DEPOSIT30 (state, deposit) {
      state.deposit30 = deposit;
    },
    SET_WITHDRAW30 (state, withdraw) {
      state.withdraw30 = withdraw;
    },
    SET_ACTIVE30 (state, data) {
      state.active30 = data;
    },
    SET_BONUS30 (state, data) {
      state.bonus30 = data;
    },
    SET_DEPOSITCOMPARE (state, data) {
      state.revenueComparisonLine = data;
    },
    SET_WITHDRAWCOMPARE (state, data) {
      state.revenueComparisonLine2 = data;
    },
    SET_TOTALCOMPARE (state, data) {
      state.revenueComparisonLine3 = data;
    },
    SET_ACTIVECOMPARE (state, data) {
      state.revenueComparisonLine4 = data;
    },
    SET_CACHE (state,data){
      state.cache = data;
    },
    SET_FIRSTCREDIT (state, data) {
      state.firstcredit = data;
    },
    SET_FIRSTCREDIT_NEW (state, data) {
      state.firstcreditNew = data;
    },
    SET_FIRSTCREDIT_OLD (state, data) {
      state.firstcreditOld = data;
    },
    updateField,
  },
  actions,
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField,
  },
}

